import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  PurchaseOrderUnApprovalReasonBean,
  PurchaseOrderUnApprovalReasonSearchCriteria,
  RestPurchaseOrderUnApprovalReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";

class PurchaseOrderUnApprovalReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };

  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  deleteOnClick = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteOnClick(val, rowData);
  };

  editPurchaseOrderUnApprovalReason = (e, val, rowData) => {
    if (e.detail === 1)
      this.props.editPurchaseOrderUnApprovalReason(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };

  render() {
    let purchaseOrderUnApprovalReason_list =
      this.props.purchaseOrderUnApprovalReason_list;
    let purchaseOrderUnApprovalReasonData =
      this.props.purchaseOrderUnApprovalReasonData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel id="searchBarLabel">
                Purchase Order UnApproval Reason
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={purchaseOrderUnApprovalReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            <tbody>
              {purchaseOrderUnApprovalReason_list.map((Info, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editPurchaseOrderUnApprovalReason(
                          e,
                          Info.code,
                          Info
                        )
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  {/* <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteOnClick(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
          {purchaseOrderUnApprovalReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class PurchaseOrderUnApprovalReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  render() {
    let purchaseOrderUnApprovalReasonData =
      this.props.purchaseOrderUnApprovalReasonData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={purchaseOrderUnApprovalReasonData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              ref={this.codeRef}
              name="code"
              type="text"
              placeholder="Enter PurchaseOrderUnApprovalReasonCode"
              onChange={this.onChange}
              value={purchaseOrderUnApprovalReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={purchaseOrderUnApprovalReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="1">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={purchaseOrderUnApprovalReasonData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class PurchaseOrderUnApprovalReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrderUnApprovalReason_list: [],
      response: {},
      pageTitle: "Purchase Order UnApproval Reason",
      purchaseOrderUnApprovalReasonData:
        new PurchaseOrderUnApprovalReasonBean(),
      pageList: new PageListBean(),
      criteria: new PurchaseOrderUnApprovalReasonSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isPurchaseOrderUnApprovalReasonListFormOpen: true,
      isPurchaseOrderUnApprovalReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let purchaseOrderUnApprovalReasonData =
      new PurchaseOrderUnApprovalReasonBean();
    purchaseOrderUnApprovalReasonData.companyCode = this.companyCode;
    this.setState({
      purchaseOrderUnApprovalReasonData: purchaseOrderUnApprovalReasonData,
    });
    this.loadPage(1);
    this.cleardata();
  }

  moduleCaption = "Purchase Order UnApproval Reason";

  cleardata = () => {
    let purchaseOrderUnApprovalReasonData =
      new PurchaseOrderUnApprovalReasonBean();
    purchaseOrderUnApprovalReasonData.companyCode = this.companyCode;
    this.setState({
      purchaseOrderUnApprovalReasonData: purchaseOrderUnApprovalReasonData,
    });
  };
  savePurchaseOrderUnApprovalReasonResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closePurchaseOrderUnApprovalReasonEntryForm();
  };
  validatePurchaseOrderUnApprovalReason = (
    purchaseOrderUnApprovalReasonData
  ) => {
    let isPurchaseOrderUnApprovalReasonData = false;
    let err_list = [];
    let errorMessage = "";
    if (purchaseOrderUnApprovalReasonData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(purchaseOrderUnApprovalReasonData.description)) {
        let errMsg = "PurchaseOrderUnApprovalReason Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(purchaseOrderUnApprovalReasonData.code)) {
        let errMsg = "PurchaseOrderUnApprovalReason Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isPurchaseOrderUnApprovalReasonData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isPurchaseOrderUnApprovalReasonData = true;
      this.setState({ isShowAlert: false });
    }
    return isPurchaseOrderUnApprovalReasonData;
  };

  savePurchaseOrderUnApprovalReason = () => {
    let purchaseOrderUnApprovalReasonData =
      this.state.purchaseOrderUnApprovalReasonData;
    let isValidLine = false;
    isValidLine = this.validatePurchaseOrderUnApprovalReason(
      purchaseOrderUnApprovalReasonData
    );
    if (isValidLine) {
      if (purchaseOrderUnApprovalReasonData.isFetched == true) {
        if (
          SecurityAccessManager.PurchaseOrderUnApprovalReasonMaintenanceEdit_IsAccessible()
        ) {
          MasterService.updatePurchaseOrderUnApprovalReason(
            purchaseOrderUnApprovalReasonData,
            this.savePurchaseOrderUnApprovalReasonResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderUnApprovalReasonMaintenanceCreate_IsAccessible()
        ) {
          MasterService.createPurchaseOrderUnApprovalReason(
            purchaseOrderUnApprovalReasonData,
            this.savePurchaseOrderUnApprovalReasonResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  editPurchaseOrderUnApprovalReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.purchaseOrderUnApprovalReason != null) {
        let purchaseOrderUnApprovalReasonData =
          response.data.purchaseOrderUnApprovalReason;
        this.setState({
          purchaseOrderUnApprovalReasonData: purchaseOrderUnApprovalReasonData,
        });
        this.disable();
      }
      this.openPurchaseOrderUnApprovalReasonEntryForm();
    }
  };

  editPurchaseOrderUnApprovalReason = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (
      SecurityAccessManager.PurchaseOrderUnApprovalReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readPurchaseOrderUnApprovalReason(
        readrestInput,
        this.editPurchaseOrderUnApprovalReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let purchaseOrderUnApprovalReasonData =
      this.state.purchaseOrderUnApprovalReasonData;
    purchaseOrderUnApprovalReasonData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderUnApprovalReasonData: purchaseOrderUnApprovalReasonData,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    this.savePurchaseOrderUnApprovalReason();
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closePurchaseOrderUnApprovalReasonEntryForm();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let purchaseOrderUnApprovalReasonData =
      this.state.purchaseOrderUnApprovalReasonData;
    this.editPurchaseOrderUnApprovalReason(
      purchaseOrderUnApprovalReasonData.code
    );
  };
  deleteOnClick = (val, rowData) => {
    //
  };
  openPurchaseOrderUnApprovalReasonEntryForm = () => {
    this.setState({
      isPurchaseOrderUnApprovalReasonListFormOpen: false,
      isPurchaseOrderUnApprovalReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closePurchaseOrderUnApprovalReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isPurchaseOrderUnApprovalReasonListFormOpen: true,
      isPurchaseOrderUnApprovalReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadPurchaseOrderUnApprovalReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderUnApprovalReasonPageList != null
    ) {
      let purchaseOrderUnApprovalReason = new Array();
      if (
        !isEmptyArray(
          response.data.purchaseOrderUnApprovalReasonPageList
            .purchaseOrderUnApprovalReason
        )
      ) {
        purchaseOrderUnApprovalReason =
          response.data.purchaseOrderUnApprovalReasonPageList
            .purchaseOrderUnApprovalReason;

        purchaseOrderUnApprovalReason.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount =
        response.data.purchaseOrderUnApprovalReasonPageList.totalCount;
      pageList.currentPage =
        response.data.purchaseOrderUnApprovalReasonPageList.currentPage;
      pageList.pageSize =
        response.data.purchaseOrderUnApprovalReasonPageList.pageSize;

      this.setState({
        purchaseOrderUnApprovalReason_list: purchaseOrderUnApprovalReason,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new PurchaseOrderUnApprovalReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadPurchaseOrderUnApprovalReasonPage(pageInput, criteria);
  };
  loadPurchaseOrderUnApprovalReasonPage = (pageList, searchCriteria) => {
    let requestInput = new RestPurchaseOrderUnApprovalReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = searchCriteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.PurchaseOrderUnApprovalReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getPurchaseOrderUnApprovalPageList(
        requestInput,
        this.loadPurchaseOrderUnApprovalReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.purchaseOrderUnApprovalReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ purchaseOrderUnApprovalReason_list: sorted });
    }
  };

  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isPurchaseOrderUnApprovalReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isPurchaseOrderUnApprovalReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isPurchaseOrderUnApprovalReasonListFormOpen && (
          <PurchaseOrderUnApprovalReasonListForm
            {...this.state}
            onChange={this.onChange}
            enterKeyEventHandler={this.enterKeyEventHandler}
            opentypeforms={this.opentypeforms}
            deleteOnClick={this.deleteOnClick}
            editPurchaseOrderUnApprovalReason={
              this.editPurchaseOrderUnApprovalReason
            }
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isPurchaseOrderUnApprovalReasonEntryFormOpen && (
          <PurchaseOrderUnApprovalReasonEntryForm
            {...this.state}
            onChange={this.onChange}
          />
        )}
      </div>
    );
  }
}

function PurchaseOrderUnApprovalReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <PurchaseOrderUnApprovalReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default PurchaseOrderUnApprovalReasonAttributeModule;
